export const works = [
  {
    id: "huoyan-yizhi",
    title: "火焰意志",
    author: "木叶落樱",
    categoryId: "changpian",
    status: "连载中",
    chapters: 186,
    words: "89.2万",
    rating: 9.6,
    views: "1280万",
    favorites: "46.8万",
    updated: "3天前更新",
    cover: "https://readdy.ai/api/search-image?query=anime%20boy%20in%20orange%20hooded%20cloak%20standing%20on%20a%20rooftop%20at%20dusk%2C%20glowing%20ember%20particles%20rising%20into%20the%20sky%2C%20deep%20charcoal%20night%20background%2C%20warm%20fire%20orange%20rim%20lighting%2C%20cinematic%20fan%20art%2C%20epic%20and%20moody%20atmosphere&width=600&height=800&seq=work-fire-will&orientation=portrait",
    tags: ["热血", "成长", "长篇"],
    summary: "少年在忍界废墟中继承前代火影的意志，踏上守护木叶、追寻和平的漫长旅途。",
    intro: "第三次忍界大战结束后，木叶村满目疮痍。一个名为悠介的少年在一次任务中意外继承了前代火影留下的查克拉火种，从此被卷入各方势力角逐的中心。他既要面对村内暗部的试探，又要应对外部忍村的步步紧逼。在一次次生死抉择中，悠介逐渐理解'火之意志'的真正含义——不是燃烧自己照亮别人，而是让每一团微火都能各自燃烧。作品以严谨的世界观考据和长线人物成长著称，是目前同人圈公认的长篇标杆之一。",
  },
  {
    id: "wuming-ying",
    title: "无名之影",
    author: "暗部茶泡饭",
    categoryId: "rexue",
    status: "连载中",
    chapters: 72,
    words: "31.5万",
    rating: 9.2,
    views: "685万",
    favorites: "22.7万",
    updated: "1天前更新",
    cover: "https://readdy.ai/api/search-image?query=ninja%20in%20dark%20mask%20and%20black%20cloak%20holding%20a%20kunai%2C%20moonlit%20forest%20at%20night%2C%20silver%20moonlight%20through%20trees%2C%20crimson%20and%20charcoal%20palette%2C%20moody%20cinematic%20fan%20art%2C%20stealthy%20and%20dramatic%20atmosphere&width=600&height=800&seq=work-shadow&orientation=portrait",
    tags: ["暗部", "战斗", "悬疑"],
    summary: "一名无名暗部忍者穿梭于黑暗之中，在权力博弈里守护自己相信的正义。",
    intro: "木叶暗部深处，代号'零'的忍者没有名字、没有过去，只有一串需要执行的任务。他游走于火之国大名、木叶高层与各大忍村之间，每一次出刀都让局势发生微妙变化。当一桩旧案将他与十年前木叶惨案的真相相连，零不得不重新审视自己守护的究竟是什么。作品以快节奏战斗和层层反转见长，暗部题材爱好者必追之作。",
  },
  {
    id: "yige-liantian",
    title: "一乐拉面的午后",
    author: "面汤铺掌柜",
    categoryId: "qingshui",
    status: "已完结",
    chapters: 41,
    words: "12.8万",
    rating: 9.4,
    views: "412万",
    favorites: "18.3万",
    updated: "完结",
    cover: "https://readdy.ai/api/search-image?query=cozy%20small%20ramen%20shop%20interior%20at%20golden%20afternoon%20light%2C%20steaming%20bowl%20of%20noodles%20on%20wooden%20counter%2C%20warm%20amber%20and%20orange%20tones%2C%20soft%20nostalgic%20anime%20background%2C%20gentle%20and%20heartwarming%20atmosphere&width=600&height=800&seq=work-ramen&orientation=portrait",
    tags: ["日常", "治愈", "短篇"],
    summary: "以一乐拉面店为舞台，串联起木叶村民平凡而温暖的日常群像。",
    intro: "无论忍界风云如何变幻，一乐拉面的汤头永远滚烫。这家小小的面店迎来送往着忍者、村民与过客，每个人都会在这里放下伪装，聊一聊最近的烦心事。作品以单元剧的形式，用一碗碗拉面串起木叶的四季与人心，没有惊天动地的战斗，只有恰到好处的温柔。疲惫时的治愈首选，口碑极佳。",
  },
  {
    id: "qianshi-zhe",
    title: "前世者",
    author: "卷轴上的名字",
    categoryId: "chuanyue",
    status: "连载中",
    chapters: 104,
    words: "56.7万",
    rating: 9.0,
    views: "742万",
    favorites: "25.1万",
    updated: "5天前更新",
    cover: "https://readdy.ai/api/search-image?query=young%20man%20in%20modern%20clothes%20surrounded%20by%20glowing%20seal%20glyphs%20and%20spiraling%20chakra%20energy%2C%20portal%20of%20light%20in%20a%20dark%20room%2C%20amber%20and%20deep%20blue%20contrast%2C%20cinematic%20isekai%20fan%20art%2C%20mysterious%20and%20dynamic&width=600&height=800&seq=work-reborn&orientation=portrait",
    tags: ["穿越", "智商在线", "爽文"],
    summary: "现代青年魂穿木叶，带着前世知识与谨慎，在忍界步步为营改写命运。",
    intro: "一名普通的现代上班族在一次意外中醒来，发现自己成了木叶村一名下忍。凭借前世的记忆与冷静头脑，他没有选择高调逆天，而是像下棋一般经营起自己的人脉与资源。当大蛇丸的阴影、晓组织的动向逐一逼近，他终于意识到：这场穿越并不是单纯的观光旅行，而是一场必须全力以赴的生存博弈。设定严谨、不降智，穿越文中的清流。",
  },
  {
    id: "shangying-kaoshi",
    title: "上忍考试：代号风神",
    author: "白毛猫耳",
    categoryId: "yuanzhu",
    status: "连载中",
    chapters: 38,
    words: "19.4万",
    rating: 8.9,
    views: "356万",
    favorites: "12.9万",
    updated: "6天前更新",
    cover: "https://readdy.ai/api/search-image?query=ninja%20squads%20facing%20a%20huge%20ancient%20test%20gate%20in%20a%20misty%20forest%2C%20wind%20and%20leaf%20particles%20swirling%2C%20warm%20golden%20and%20charcoal%20tones%2C%20epic%20anime%20fan%20art%2C%20adventure%20and%20determination&width=600&height=800&seq=work-exam&orientation=portrait",
    tags: ["原著向", "考试", "群像"],
    summary: "还原原著设定，讲述一届特殊上忍考试中的规则、博弈与青春热血。",
    intro: "木叶将举办一届规格罕见的特别上忍考试，各村精英下忍齐聚一堂。作品以原著时间线为基底，围绕'风神小队'在考试中的见闻与成长展开，考据严谨地呈现了原著中的忍术体系与村镇关系。作者擅长多线叙事，将考试中的战略博弈与人物羁绊交织得张弛有度，原著党也能收获别样乐趣。",
  },
  {
    id: "yueliang-yige-ren",
    title: "月亮与两个人",
    author: "忍界手帐",
    categoryId: "ganqing",
    status: "连载中",
    chapters: 29,
    words: "8.6万",
    rating: 9.1,
    views: "298万",
    favorites: "15.6万",
    updated: "2天前更新",
    cover: "https://readdy.ai/api/search-image?query=two%20silhouettes%20sitting%20on%20a%20roof%20under%20a%20huge%20full%20moon%2C%20night%20breeze%20and%20floating%20petals%2C%20soft%20silver%20and%20warm%20amber%20glow%2C%20gentle%20romantic%20anime%20fan%20art%2C%20quiet%20and%20tender%20atmosphere&width=600&height=800&seq=work-moon&orientation=portrait",
    tags: ["感情线", "细腻", "青春"],
    summary: "从并肩作战到怦然心动，两个性格迥异的忍者在月夜下渐渐靠近。",
    intro: "一个话少面冷的忍者，一个阳光外向的同期生，两个本不该有交集的人因为一次次任务被绑在一起。作品以极其细腻的心理描写见长，将忍者的克制与少年少女的心动拿捏得恰到好处，既不甜腻也不刻意。作者对人物互动的把握被读者誉为'教科书级别'，感情线爱好者强烈推荐。",
  },
  {
    id: "wuye-liuwu",
    title: "午夜六室",
    author: "猫头鹰笔客",
    categoryId: "duanpian",
    status: "已完结",
    chapters: 16,
    words: "4.2万",
    rating: 8.8,
    views: "187万",
    favorites: "9.4万",
    updated: "完结",
    cover: "https://readdy.ai/api/search-image?query=mysterious%20empty%20hospital%20corridor%20lit%20by%20a%20single%20warm%20lamp%20at%20midnight%2C%20faint%20silhouette%20at%20the%20end%2C%20dark%20charcoal%20with%20orange%20light%20spill%2C%20cinematic%20suspenseful%20anime%20fan%20art%2C%20eerie%20and%20atmospheric&width=600&height=800&seq=work-midnight&orientation=portrait",
    tags: ["悬疑", "短篇", "灵异"],
    summary: "十六个深夜小故事，在木叶的阴影里寻找答案与人心。",
    intro: "午夜的木叶并不总是灯火通明。在村子的角落里，流传着十六则关于'第六间诊疗室'的传闻。短篇集以单元形式展开，从被封印的忍具到深夜敲门的身影，每个故事都围绕一个谜题与一段人心展开。作者擅于营造氛围，结尾留白恰到好处，适合睡前一口气读完。",
  },
  {
    id: "xueji-heiying",
    title: "血继之影",
    author: "红瞳记事",
    categoryId: "rexue",
    status: "连载中",
    chapters: 96,
    words: "43.1万",
    rating: 9.3,
    views: "803万",
    favorites: "29.2万",
    updated: "4天前更新",
    cover: "https://readdy.ai/api/search-image?query=ninja%20with%20glowing%20red%20eyes%20unleashing%20crimson%20chakra%20flames%2C%20dark%20battlefield%20with%20ember%20sparks%2C%20red%20and%20black%20palette%2C%20intense%20cinematic%20anime%20fan%20art%2C%20fierce%20and%20powerful&width=600&height=800&seq=work-bloodline&orientation=portrait",
    tags: ["血继限界", "战斗", "虐心"],
    summary: "身负禁忌血继的少年在偏见与追杀中觉醒，血与火中淬炼自己的道路。",
    intro: "木叶边陲的一户人家，世代隐藏着被列为禁忌的血继限界。少年晓岚觉醒能力的那一天，平静的生活被彻底打破——村子觊觎、他村追杀、昔日同伴避之不及。他不得不在血与火中一次次证明自己。作品战斗场面酣畅淋漓，人物情感却极为克制深沉，虐心与热血并存，让人欲罢不能。",
  },
  {
    id: "chuntian-laile",
    title: "春天来了",
    author: "木叶邮差",
    categoryId: "qingshui",
    status: "已完结",
    chapters: 24,
    words: "7.3万",
    rating: 9.0,
    views: "265万",
    favorites: "13.7万",
    updated: "完结",
    cover: "https://readdy.ai/api/search-image?query=village%20street%20in%20early%20spring%20with%20cherry%20blossom%20petals%20falling%2C%20children%20playing%20and%20ninja%20relaxing%2C%20warm%20golden%20morning%20light%2C%20soft%20peach%20and%20amber%20tones%2C%20hopeful%20anime%20fan%20art%2C%20gentle%20and%20bright%20atmosphere&width=600&height=800&seq=work-spring&orientation=portrait",
    tags: ["治愈", "战后", "短篇"],
    summary: "战争结束后的第一个春天，木叶每个人都在努力重新学会生活。",
    intro: "第四次忍界大战落幕，木叶迎来了久违的春天。失去亲人的孩子、退役的忍者、重建的家园，在这个春天里，每个人都在用自己的方式重新学会生活。作品没有宏大的战斗，只有琐碎却动人的日常——一顿热饭、一场迟到已久的团圆、一个重新响起的名字。读完会让人眼眶发酸，心里却暖暖的。",
  },
  {
    id: "wode-laoshi-shidaimu",
    title: "我的老师是代目",
    author: "影分身之梦",
    categoryId: "chuanyue",
    status: "连载中",
    chapters: 118,
    words: "61.3万",
    rating: 8.7,
    views: "532万",
    favorites: "19.8万",
    updated: "2天前更新",
    cover: "https://readdy.ai/api/search-image?query=young%20student%20ninja%20training%20under%20a%20mature%20robed%20teacher%20with%20flaming%20aura%20at%20sunset%20training%20ground%2C%20orange%20and%20brown%20tones%2C%20heartwarming%20epic%20anime%20fan%20art%2C%20mentorship%20and%20growth&width=600&height=800&seq=work-teacher&orientation=portrait",
    tags: ["穿越", "师徒", "轻松"],
    summary: "穿越成木叶下忍，却发现传说中的'代目'竟是自己的便宜老师。",
    intro: "主角穿越到木叶，成了村子里的普通下忍，本打算咸鱼度日。谁知某天上面安排来的带队老师，竟是被后世奉为传奇的某位'代目'。于是，一段鸡飞狗跳又不乏热血的师徒日常就此展开。作品风格轻松诙谐，师徒互动温暖有爱，同时在关键时刻也能燃到顶点，是放松心情的不错选择。",
  },
  {
    id: "yile-banzhuan",
    title: "一乐番外：汤面之道",
    author: "面汤铺掌柜",
    categoryId: "wanjie",
    status: "已完结",
    chapters: 33,
    words: "9.9万",
    rating: 9.0,
    views: "233万",
    favorites: "11.6万",
    updated: "完结",
    cover: "https://readdy.ai/api/search-image?query=master%20chef%20slicing%20green%20onions%20with%20a%20ninja%20knife%20technique%20in%20a%20warm%20kitchen%2C%20steam%20and%20golden%20light%2C%20playful%20and%20cozy%20anime%20fan%20art%2C%20amber%20and%20charcoal%20tones%2C%20humorous%20and%20warm&width=600&height=800&seq=work-noodle&orientation=portrait",
    tags: ["轻松", "美食", "群像"],
    summary: "一乐拉面背后的故事，关于一锅汤、一个人和整个木叶的羁绊。",
    intro: "如果说《一乐拉面的午后》是木叶的众生相，那么这部番外则聚焦面汤本身——手打面、高汤、秘制酱料，以及面店掌柜数十年如一日的坚持。作品用轻松诙谐的笔触，把美食描写得活色生香，也让读者重新认识了那个总在柜台后忙碌的身影。读着读着就会饿，别怪我没提醒。",
  },
  {
    id: "yuanshang-guli",
    title: "原上故里",
    author: "红瞳记事",
    categoryId: "yuanzhu",
    status: "连载中",
    chapters: 57,
    words: "26.9万",
    rating: 9.2,
    views: "478万",
    favorites: "17.4万",
    updated: "3天前更新",
    cover: "https://readdy.ai/api/search-image?query=ruined%20village%20shrine%20at%20sunrise%20with%20a%20lone%20ninja%20looking%20at%20the%20horizon%2C%20golden%20morning%20mist%20and%20warm%20light%2C%20nostalgic%20and%20poignant%20anime%20fan%20art%2C%20earthy%20amber%20tones%2C%20serene%20and%20bittersweet&width=600&height=800&seq=work-homeland&orientation=portrait",
    tags: ["原著向", "战争", "群像"],
    summary: "围绕一片被战火撕裂的故土，讲述三代忍者的选择、失去与和解。",
    intro: "火之国边缘有一片被战火反复争夺的原野，那里曾是一个小忍村的故乡。作品以三代人物的视角交叉叙事，讲述同一片故土在不同年代的故事——有人为守护它而死，有人为它流浪，也有人最终选择归来与和解。文笔克制而深沉，人物塑造立体，是原著向同人中难得的有分量的作品。",
  },
];